<template>
  <BContainer class="container-pages" >
    <BRow>
     <BCol xl="9" lg="8">
      <BRow>
        <BCol xl="5" lg="5" class="mb-2" >
          <div class="shadow rounded p-element-page bg-white">
              
              <FilterDesktop :places="element?.data?.places?.data"
                           v-if="$screen.isDesktop"
                           :categories="element?.data?.categories?.data"></FilterDesktop>
               <FilterMobile :places="element?.data?.places?.data"
                           v-else
                           :categories="element?.data?.categories?.data"></FilterMobile>
             


          </div>   
        </BCol>
         <BCol xl="7" lg="7">
           <NuxtPage v-if="!pending && !error"></NuxtPage>
        <div class="mt-3">
         <PaginationItems
          :last_page="10"></PaginationItems>
        </div>
         </BCol>
    </BRow>
    <BRow>
      <BCol>
        <div class="a-container mb-2" v-if="$screen.isProduction">
          <AdsBottomPage></AdsBottomPage>
      </div>
      </BCol>
    </BRow>
     </BCol>
     <BCol xl="3" lg="4">
      <div class="a-container mb-2" v-if="$screen.showDesktopAds">
          <AdsTopRightPage></AdsTopRightPage>
      </div>
       <TopPriceBlock :xl="12" 
                      :lg="12" 
                      :counter="3" 
                      :fix_height="false"></TopPriceBlock>
     </BCol>
    </BRow>
  </BContainer>
  
</template>

<script setup>

const route = useRoute();

const device = useDevice()


import { BContainer, BRow, BCol} from 'bootstrap-vue-next';
import FilterDesktop from '~/components/cmsCustomer/advertisement/filter/FilterDesktop'
import FilterMobile from '~/components/cmsCustomer/advertisement/filter/FilterMobile.vue';
import PaginationItems from '~/components/cmsCustomer/advertisement/display/PaginationItems.vue';
import TopPriceBlock from '~/components/widgets/Stips/TopPriceBlock.vue';
import AdsBottomPage from '~/components/GoogleAdvertisements/AdsBottomPage.vue';
import AdsTopRightPage from '~/components/GoogleAdvertisements/AdsTopRightPage.vue';
 
import { useCustomerItemsStore } from "~/stores/customer/items";
  
const useStore = useCustomerItemsStore();

const { data : element , error, pending   } = await useAsyncData(
 'element-test',
  () =>  useStore.getFilterData({
     name: '' ,
     place: route.params.place != undefined ? route.params.place.split('-').join(' ') : '',
     page: 1
   }) 
);

 
</script>

<style>

</style>
